<template>
  <div class="books-details">
    <!-- 内容 -->
    <div class="content-box">
      <!-- ---------------- -->

      <p>授权网店申请流程</p>
      <div style="height: 300px; max-width: 600px">
        <el-steps direction="vertical" :active="1">
          <el-step
            title="提交资质"
            description="提交店铺信息、公司资质等信息"
          />
          <el-step title="审核资质" description="预计审核时间1-7个工作日" />
          <el-step
            title="保证金汇款"
            description="部分店铺平台需要您支付一定的保证金。汇款到天利指定账户。"
          />
          <el-step
            title="签订协议"
            description="收到天利邮寄给您的协议后,签字盖章,然后回寄给天利。"
          />
          <el-step
            title="授权颁证"
            description="授权通过,提供可下载的电子授权证书。"
          />
        </el-steps>
      </div>
    </div>

    <!-- 按钮 -->
    <el-button type="primary" @click="startButton">开始申请</el-button>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

import { reactive, computed } from "vue";

const router = useRouter();

const mydata = reactive({
  size: "default",
});

//开始申请授权按钮点击事件
function startButton() {
  router.push({
    path: "/layout/list/progressStep",
    query: {
      step: 1,
    },
  });
}
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离
  padding-top: 16px;
  display:flex;
  flex-direction: column;
  align-items: center;
  //////内容
  .content-box {
    width: 343px;
    min-height: 470px;
    margin: 0 auto;
    padding: 16px;
    // border: 1px solid red;
    border-radius: 8px;
    background-color: #ffffff;
    overflow: hidden;
    ////////////////
    > p {
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      line-height: 28px;
      margin-bottom: 25px;
    }

    //////步骤条  ////////////////////////////////////
    > div {
      margin-left: 20px;

      // //统一设置————每个进度块
      // :deep(.el-step.is-horizontal.is-center) {
      //   width: 218px;
      //   // margin-bottom:10px;
      //   border: 1px solid blue;
      // }


      //统一设置————圆圈样式
      :deep(.el-step__icon.is-text) {
        width: 20px;
        height: 20px;
        background-color: #009de0;
        border: none;
        // border: 1px solid #a8abb2;
        //圆圈内字体
        .el-step__icon-inner {
          font-size: 12px;
          font-weight: 500;
          color: #ffffff;
        }
      }

      //统一设置————全部的第一行字
      :deep(.el-step__title) {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #333333;
        // margin-bottom: 8px;
      }

      //统一设置————全部下面的字
      :deep(.el-step__description) {
        width: 250px;
        // border:1px solid blue;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
        // padding: 0px 30px;
      }

      //统一设置————横线
      :deep(.el-step__line) {
        // border:1px solid blue;
        width: 1px;
        height: 41px;
        top: 31px;
        left: 9px;
        color: #d4d6d9;
      }
      //同意设置————头部高度
      :deep(.el-step__head){
        // border: 1px solid rgb(255, 0, 242);
        height: 78px;
        // height: auto;
      }

     
      /******************************
      /////【完成状态】————的样式////////////
      :deep(.el-step__head.is-finish) {
        //圆圈
        .el-step__icon.is-text {
          background-color: #009de0;
          border: none;
        }
        //圆圈内字体
        .el-step__icon-inner {
          color: #ffffff;
        }
      }
      /////完成状态————的第一行字的样式
      :deep(.el-step__title.is-finish) {
        color: #333333;
      }
      /////完成状态————的下面字的样式
      :deep(.el-step__description.is-finish) {
        color: #333333;
      }

      ////【进程状态】——————的样式/////////////
      :deep(.el-step__head.is-process) {
        //圆圈
        .el-step__icon.is-text {
          border-color: #a8abb2;
        }
        //圆圈内字体
        .el-step__icon-inner {
          color: #a8abb2;
        }
      }
      ////进程状态——————的第一行字的样式
      :deep(.el-step__title.is-process) {
        color: #bbbdbf;
      }
      ////进程状态————下面字的样式
      :deep(.el-step__description.is-process) {
        color: #bbbdbf;
      }

      ////【等待状态】——————的样式/////////////
      :deep(.el-step__head.is-wait) {
        //圆圈
        .el-step__icon.is-text {
          border-color: #a8abb2;
        }
        //圆圈内字体
        .el-step__icon-inner {
          color: #a8abb2;
        }
      }

      ////等待状态——————的第一行字的样式
      :deep(.el-step__title.is-wait) {
        color: #bbbdbf;
      }

      ////等待中————下面字的样式
      :deep(.el-step__description.is-wait) {
        color: #bbbdbf;
      }
*********************/
    }

  }

  //////按钮
  .el-button.el-button--primary{
    width:343px;
    height:42px;
    margin-top:16px;
    border-radius: 8px;
    font-size:14px;

  }

}
</style>